import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import moment from 'moment';
import { ISpeakerSeries } from '../../types/datatypes';

@Component({
	selector: 'app-card-resource',
	templateUrl: './card-resource.component.html',
	styleUrls: ['./card-resource.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CardResourceComponent {
	@Input() resource: ISpeakerSeries;

	@Input() author;

	constructor() { }

	get resourceLink() {
		return `/author-dashboard/${this.author?.authorLink}/resources/${this.resource._id}`;
	}

	resourceDate(date) {
		return moment(date).format('MMMM YYYY');
	}
}
